import { render, staticRenderFns } from "./AamsReceptionBaseStandard.vue?vue&type=template&id=554924af&scoped=true&"
import script from "./AamsReceptionBaseStandard.vue?vue&type=script&lang=js&"
export * from "./AamsReceptionBaseStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554924af",
  null
  
)

export default component.exports